import { render, staticRenderFns } from "./getiDetail.vue?vue&type=template&id=6951d68e&scoped=true&"
import script from "./getiDetail.vue?vue&type=script&lang=js&"
export * from "./getiDetail.vue?vue&type=script&lang=js&"
import style0 from "./getiDetail.vue?vue&type=style&index=0&id=6951d68e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6951d68e",
  null
  
)

export default component.exports